var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBuilding3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.667 39.875a1.375 1.375 0 0 1-.187-2.737l.187-.013h.458v-19.25a3.438 3.438 0 0 1 3.169-3.427l.269-.01.687-.001v-2.75a3.438 3.438 0 0 1 3.249-3.432l.188-.005h.688V5.5a1.375 1.375 0 0 1 2.737-.187l.013.187v2.75h.688a3.438 3.438 0 0 1 3.432 3.249l.005.188v2.75h.688c.235 0 .465.024.688.07l-.001-2.22a3.731 3.731 0 0 1 2.154-3.39l.268-.112 11.786-4.413a3.733 3.733 0 0 1 5.029 3.183l.013.304v29.266h.458a1.375 1.375 0 0 1 .187 2.737l-.187.013H3.667zm16.27-22.688H7.563a.688.688 0 0 0-.673.55l-.014.138v19.25h5.5v-1.718a1.375 1.375 0 0 1 2.737-.186l.013.186v1.718h5.5v-19.25a.688.688 0 0 0-.549-.674l-.139-.014zm16.045-10.29-.184.05-11.786 4.413a.98.98 0 0 0-.622.75l-.015.173v24.842h13.75V7.865a.983.983 0 0 0-1.143-.967zM27.5 15.23c.696 0 1.271.518 1.362 1.189l.013.187v14.562a1.375 1.375 0 0 1-2.737.186l-.013-.186V16.604c0-.759.616-1.374 1.375-1.374zm5.5 0c.696 0 1.271.518 1.362 1.189l.013.187v14.562a1.375 1.375 0 0 1-2.737.186l-.013-.186V16.604c0-.759.616-1.374 1.375-1.374zM16.845 26.813a1.375 1.375 0 0 1 .186 2.737l-.186.012h-6.188a1.375 1.375 0 0 1-.186-2.737l.186-.012h6.188zm0-6.188a1.375 1.375 0 0 1 .186 2.737l-.186.013h-6.188a1.375 1.375 0 0 1-.186-2.737l.186-.013h6.188zM15.813 11h-4.126a.688.688 0 0 0-.68.586l-.007.101v2.75h5.5v-2.75a.688.688 0 0 0-.448-.644l-.1-.029-.14-.014z",
    fill: "#9EA2FA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBuilding3);
export default __webpack_public_path__ + "static/media/icons-building-3.3d36497b3dbe5f262039bfd7e15158d6.svg";
export { ForwardRef as ReactComponent };